<template>
  <div class="invite">
    <div class="logo">
      <img src="../assets/logo2.jpg" alt="" />
      <p>闲至优品APP</p>
      <p>闲物新生 品质至上</p>
    </div>
    <van-form
      validate-first
      @failed="onFailed"
      @submit="onSubmit"
      :submit-on-enter="true"
    >
      <!-- 通过 pattern 进行正则校验 -->
      <van-field
        v-model="phone"
        name="phone"
        left-icon="graphic"
        class="phone"
        placeholder="请输入手机号"
        :rules="[{ pattern, message: '请输入正确的手机号！' }]"
      />
      <!-- 通过 validator 进行函数校验 -->
      <div class="code">
        <van-field
          v-model="code"
          name="code"
          left-icon="chat-o"
          placeholder="请输入短信验证码"
          :rules="[{ validator, message: '请输入正确的短信验证码！' }]"
        />
        <div class="code_box">
          <van-button
            native-type="button"
            plain
            type="primary"
            v-show="isCode"
            @click="getCode"
            >获取验证码</van-button
          >
          <van-button
            native-type="button"
            plain
            type="primary"
            v-show="!isCode"
            >{{ Codecount }}</van-button
          >
        </div>
      </div>
      <!-- 通过 validator 进行异步函数校验 -->
      <div style="margin: 5px" class="submit">
        <van-button round block type="danger" native-type="submit"
          >立即领取</van-button
        >
      </div>
    </van-form>
    <van-popup v-model="isShow" class="oldUser" closeable>
      <p>您已经是闲至优品老用户了哦，不能重复领取。</p>
      <van-button round block type="danger" @click="downloadApp"
        >打开APP去购物</van-button
      >
    </van-popup>
    <van-popup v-model="isShow2" class="suUser" closeable>
      <p>领取成功</p>
      <p>恭喜获得518元新人大礼包</p>
      <img src="../assets/icon.png" alt="" />
      <van-button round block type="danger" @click="downloadApp"
        >下载APP去购物</van-button
      >
    </van-popup>
  </div>
</template>

<script>
import { AesEncryptECB } from "../utils/aes_util.js";
export default {
  data() {
    return {
      phone: "",
      code: "",
      invitationCode: "",
      pattern: /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/,
      //验证码相关
      isCode: true,
      Codecount: "",
      timer: null,
      isShow: false,
      isShow2: false,
      isIos: false,
      isAndroid: false,
      schemeUrl: "",
      downloadUrl: "http://qr15.cn/F6fhRD"
    };
  },
  created() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isAndroid) {
      this.isAndroid = true;
      this.schemeUrl = "xzyp://com.xzyp.app";
      this.downloadUrl = "http://qr15.cn/F6fhRD";
    }
    if (isIOS) {
      this.isIos = true;
      this.schemeUrl = "tencent101482537://";
      this.downloadUrl = "http://qr15.cn/F6fhRD";
    }
  },
  mounted() {
    this.invitationCode = this.$route.query.invitationCode;
  },
  methods: {
    validator(val) {
      return /^\d{1,6}$/.test(val);
    },
    onFailed(errorInfo) {
      console.log("failed", errorInfo);
      this.$toast(errorInfo.errors[0].message);
    },
    onSubmit(values) {
      console.log("submit", values);
      this.axios({
        method: "post",
        url: "api/user/register",
        data: {
          phone: this.phone,
          captcha: this.code,
          invitationCode: this.invitationCode
        }
      }).then(res => {
        if (res.data.code == 200) {
          this.isShow2 = true;
          this.isShow = false;
        } else if (res.data.code == 400 && res.data.message == "用户已被注册") {
          this.isShow = true;
          this.isShow2 = false;
        } else {
          this.$toast(res.data.message);
        }
      });
      // this.isShow = true;
    },
    getCode() {
      const TIME_COUNT = 60;
      let that = this;
      if (!this.timer) {
        this.Codecount = TIME_COUNT;
        this.isCode = false;
        AesEncryptECB(this.phone, function(token) {
          that
            .axios({
              method: "post",
              url: "api/user/sendMessage",
              data: {
                phone: that.phone,
                token: token
              }
            })
            .then(res => {
              console.log(res);
              if (res.data.code == 200) {
                that.$toast("发送验证码成功");
              }
            });
        });
        this.timer = setInterval(() => {
          if (this.Codecount > 0 && this.Codecount <= TIME_COUNT) {
            this.Codecount--;
          } else {
            this.isCode = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    downloadApp() {
      if (!this.isBlackApp()) {
        this.isShow = true;
        this.openTuer();
      } else {
        //显示手动打开外置浏览器提示
        this.isShow = false;
        this.openTuer();
        // this.$toast("请在右上角选择默认浏览器打开");
      }
    },
    isBlackApp() {
      var u = navigator.userAgent.toLowerCase();
      return (
        /micromessenger/i.test(u) ||
        u.indexOf("weibo") > -1 ||
        u.indexOf("qq") > -1 ||
        u.indexOf("mqqbrowser") > -1
      );
    },
    // 点击打开app
    openTuer() {
      this.jumpApp(this.schemeUrl);
      this.noApp();
      setTimeout(() => {
        this.isShow = false;
      }, 1000);
    },
    // 跳转打开app
    jumpApp(t) {
      console.log(t);
      try {
        var e = navigator.userAgent.toLowerCase(),
          n = e.match(/cpu iphone os (.*?) like mac os/);
        if (
          ((n = null !== n ? n[1].replace(/_/g, ".") : 0), parseInt(n) >= 9)
        ) {
          window.location.href = t;
        } else {
          var r = document.createElement("iframe");
          (r.src = t), (r.style.display = "none"), document.body.appendChild(r);
        }
      } catch (e) {
        window.location.href = t;
      }
    },
    // 无响应或者没安装跳转下载
    noApp() {
      var t = Date.now(),
        r = this.downloadUrl;
      console.log(r);
      this.timer = setTimeout(function() {
        return Date.now() - t > 2200
          ? (clearTimeout(this.timer), !1)
          : !document.webkitHidden &&
              !document.hidden &&
              void (location.href = r);
      }, 2000);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.van-field__error-message {
  display: none;
}
.invite {
  width: 100%;
  height: 100vh;
  background: url("../assets/lQDPDhsuIQJTcMXNAyrNAXewPhxC179hqK4CHEA3nACpAA_375_810.jpg")
    no-repeat;
  background-size: 100% 100%;
  position: relative;
  overflow: hidden;
  .logo {
    margin: 20px;
    img {
      width: 40px;
      float: left;
      vertical-align: middle;
      margin-right: 10px;
    }
    p {
      text-align: left;
      font-weight: 600;
      color: #fff;
      font-size: 14px;
    }
  }
  .van-form {
    position: absolute;
    left: 0px;
    bottom: 20px;
    width: 100%;
    box-sizing: border-box;
    padding: 0 30px;
    /deep/.van-icon {
      color: #999;
      font-size: 18px;
    }
    .phone {
      border-radius: 20px;
      margin-bottom: 20px;
    }
    .submit {
      .van-button {
        margin: 0 auto;
        border: none;
        width: 80%;
      }
    }
  }
  .van-cell::after {
    border-bottom: none !important;
  }
  .code {
    margin-bottom: 25px;
    width: 100%;
    border-radius: 20px;
    background: #fff;
    overflow: hidden;

    .van-field {
      float: left;
      width: 70%;
      border: none;
      margin: 0;
    }
    .code_box {
      height: 100%;
      width: 30%;
      float: right;
    }
    .van-button {
      font-size: 12px;
      border: none;
      width: 85px;
      padding: 0;
      color: red;
    }
  }
  .oldUser {
    width: 332px;
    height: 412px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 40px 12px;
    background: url("../assets/igghqlwlsaf.png") no-repeat;
    background-size: contain;
    p {
      text-align: center;
      font-size: 16px;
      padding: 0 40px;
      margin-bottom: 40px;
      margin-top: 160px;
    }
    .van-button {
      margin: 0 auto;
      margin-bottom: 26px;
      background-image: radial-gradient(#ff9629, #ff9327, #ff9024, #ffd06c);
      border: none;
      width: 80%;
    }
    b {
      font-weight: normal;
      font-size: 12px;
      text-decoration: underline;
      color: #f95e5a;
    }
  }
  .suUser {
    width: 332px;
    height: 420px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 40px 12px;
    background: url("../assets/igghqlwlsaf.png") no-repeat;
    background-size: contain;
    p {
      text-align: center;
      font-size: 14px;
      margin-bottom: 10px;
      margin-top: 130px;
      color: red;
      &:nth-child(2) {
        margin-top: 0;
        font-size: 16px;
      }
    }

    img {
      width: 64px;
      margin-bottom: 25px;
      position: relative;
      animation: mymove 5s infinite;
      -webkit-animation: mymove 5s infinite; /*Safari and Chrome*/
      animation-direction: alternate; /*轮流反向播放动画。*/
      animation-timing-function: ease-in-out; /*动画的速度曲线*/
      /* Safari 和 Chrome */
      -webkit-animation: mymove 5s infinite;
      -webkit-animation-direction: alternate; /*轮流反向播放动画。*/
      -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/
    }
    @keyframes mymove {
      0% {
        transform: scale(1); /*开始为原始大小*/
      }
      25% {
        transform: scale(1.1); /*放大1.1倍*/
      }
      50% {
        transform: scale(1);
      }
      75% {
        transform: scale(1.1);
      }
    }

    @-webkit-keyframes mymove /*Safari and Chrome*/ {
      0% {
        transform: scale(1); /*开始为原始大小*/
      }
      25% {
        transform: scale(1.1); /*放大1.1倍*/
      }
      50% {
        transform: scale(1);
      }
      75% {
        transform: scale(1.1);
      }
    }
    .van-button {
      margin: 0 auto;
      width: 80%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/invite.vue